import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { BlackPointStatus } from './models/BlackPointStatus';

export const BlackPointStatusStore = types
  .compose(
    getBaseStore<Instance<typeof BlackPointStatus>, Instance<typeof BlackPointStatus>>(
      BlackPointStatus,
      'blackPointStatusId',
      'blackPointStatus',
    ),
    types.model('BlackPointStatusStore', {}),
  )
  .actions((self) => {
    return {
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type BlackPointStatusStoreType = Instance<typeof BlackPointStatusStore>;
